// extracted by mini-css-extract-plugin
export var quantityInput = "_eh-0";